namespace Ir.Components.Filters.PreviousNextDate {
    interface IFilterViewModel {
        filter: Filter;
        element: JQuery<HTMLElement>;
        onPreviousDateClick: Function;
        onNextDateClick: Function;

        disabled: KnockoutComputed<boolean>;
    }

    interface IPreviousNextParameterVM {
        filter: Filter;
        element: JQuery<HTMLElement>;
    }

    export function getViewModel(this: IFilterViewModel, params: IPreviousNextParameterVM) {
        let self = this;
        this.filter = params.filter;
        this.element = params.element;

        this.onPreviousDateClick = function (model, evt) {
            evt.stopPropagation();

            if (self.filter.readOnly()) {
                return;
            }

            if (self.filter.previousDateClick) {
                self.filter.previousDateClick();
            }
        };
        this.onNextDateClick = function (model, evt) {
            evt.stopPropagation();

            if (self.filter.readOnly()) {
                return;
            }

            if (self.filter.nextDateClick) {
                self.filter.nextDateClick();
            }
        };

        this.disabled = ko.computed(() => { return self.filter.startCondition() === null; });
    }
}